// import { Divider } from "@mui/material";
import {
    SecondaryText,
    SingleCardItem,
    SubTitle,
    Title,
} from "components/views/ui";

const ARXIV2025 = () => {
    return (
        <SingleCardItem>
            <Title
                title={
                    "Stealtooth: Breaking Bluetooth Security Abusing Silent Automatic Pairing"
                }
                hyperLink="https://arxiv.org/abs/2507.00847"
            />
            <SubTitle
                title={
                    "arXiv"
                }
            />
            <SubTitle
                title={
                    "Keiichiro Kimura, Hiroki Kuzuno, Yoshiaki Shiraishi, and Masakatu Morii"
                }
            />
            <SecondaryText text="First Author" />
            <SecondaryText text="Preprint Paper" />
            <SecondaryText text="2025-07-01" />
            <SecondaryText text="Thank you for your interest in our work!" />
            <SecondaryText text=" - New Bluetooth Attack “Stealtooth” Hijacks Connections Without Users Ever Noticing" hyperLink="https://cyberinsider.com/new-bluetooth-attack-stealtooth-hijacks-connections-without-users-ever-noticing/" />
            <SecondaryText text=" - Bluetooth Vulnerabilities in 2026: The Growing Need for Continuous Visibility" hyperLink="https://bastille.net/bluetooth-vulnerabilities-2026-continuous-monitoring/" />
            <SecondaryText text=" - Unpacking Bluetooth How the Wireless Standard Operates" hyperLink="https://heqingele.com/blog/how-does-bluetooth-work-technical-explanation/" />
            <SecondaryText text=" - Bluetooth Security Timeline" hyperLink="https://darkmentor.com/bt.html" />
            <SecondaryText text=" - OffensiveReading" hyperLink="https://github.com/BitnomadLive/OffensiveReading/blob/main/README.md" />
            <SecondaryText text=" - Is Bluetooth safe to use?" hyperLink="https://www.reddit.com/r/GrapheneOS/comments/1t66f1i/is_bluetooth_safe_to_use/" />
        </SingleCardItem>
    );
};

export default ARXIV2025;
